import { useQuery } from '@tanstack/react-query';

import { baoCaoRepository } from '../../../lib/repositories/bao-cao.repository';
import type { BaoCaoTho } from '../types';

/** Số liệu thô của màn `Báo cáo & Thống kê`; gom số liệu ở view qua `tongHop`. */
export function useBaoCao() {
  return useQuery<BaoCaoTho>({
    queryKey: ['bao-cao', 'tong-hop'],
    queryFn: baoCaoRepository.tai,
    staleTime: 60_000,
  });
}
